import { apiService } from "../services/axios";
import { useEffect, useState } from 'react';
import { ARRAN_WAR_CATEGORY_CODE, ARRAN_WAR_CROSSOVER_CATEGORY_CODE } from '../utils/categoryTranslations';
import iconBook from '../assets/icon-book.png';

const SharedComicList = ({ comics: sharedComics, categoryCode }) => {
    const [allComics, setAllComics] = useState([]);

    useEffect(() => {
        apiService.getPublic('/api/comics')
            .then((response) => {
                setAllComics(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const sharedComicIds = sharedComics ? sharedComics.map((comic) => comic.comicId) : [];

    const comicsByCategory = allComics.reduce((groups, comic) => {
        const comicCategoryCode = comic.mainCategory.code;
        const isArranWarCrossoverFilter = categoryCode === ARRAN_WAR_CROSSOVER_CATEGORY_CODE;
        const isInFilteredCategory = comicCategoryCode === categoryCode;
        const isCrossoverForArranWar = isArranWarCrossoverFilter && comic.belongsToArranWarCrossover;

        // Si un categoryCode est spécifié : catégorie stricte, sauf pour "Guerres d'Arran (crossover)" qui inclut les crossovers
        if (categoryCode !== null && categoryCode !== undefined && !isInFilteredCategory && !isCrossoverForArranWar) {
            return groups;
        }

        const groupKey = isCrossoverForArranWar ? ARRAN_WAR_CATEGORY_CODE : comicCategoryCode;
        const groupName = groupKey === ARRAN_WAR_CATEGORY_CODE && comicCategoryCode !== ARRAN_WAR_CATEGORY_CODE
            ? "Guerres d'Arran"
            : comic.mainCategory.name;

        if (!groups[groupKey]) {
            groups[groupKey] = {
                name: groupName,
                comics: []
            };
        }
        groups[groupKey].comics.push(comic);
        return groups;
    }, {});

    if (categoryCode === ARRAN_WAR_CROSSOVER_CATEGORY_CODE && comicsByCategory[ARRAN_WAR_CATEGORY_CODE]) {
        comicsByCategory[ARRAN_WAR_CATEGORY_CODE].comics.sort((a, b) =>
            (b.releaseDate || '').localeCompare(a.releaseDate || '')
        );
    }

    return (
        <div>
            {Object.entries(comicsByCategory).map(([categoryCode, categoryData]) => (
                <div key={categoryCode}>
                    <h2 className="title is-3 p-4 mb-4">
                        {categoryData.name}
                    </h2>

                    <div className="fixed-grid grid has-3-cols has-1-cols-mobile">
                        <div className="grid">
                            {categoryData.comics.map((comic) => (
                                <div key={comic.id} className={"card large " + (sharedComicIds.includes(comic.id) ? 'has-background-success-light' : 'has-background-danger-light')}>
                                    <div className="card-image">
                                        <figure className="image">
                                            <img src={comic.imageUrl} alt={comic.title} />
                                        </figure>
                                    </div>
                                    <div className="card-content">
                                        <div className="media">
                                            <div className="media-left">
                                                <figure className="image is-48x48">
                                                    <img src={iconBook} alt="Book icone" />
                                                </figure>
                                            </div>
                                            <div className="media-content">
                                                <p className="title is-4 no-padding">{comic.title}</p>
                                                <p>
                                                    <span className="title is-6">{comic.mainCategory.name} #{comic.volumeNumber}</span>
                                                </p>
                                                <p className="subtitle is-6">
                                                    Paru le {comic.releaseDateFormatted}
                                                    {comic.editionName !== null &&
                                                        <><br/>{comic.editionName}</>
                                                    }
                                                    {comic.belongsToArranWarCrossover &&
                                                        <><br/><strong><span className="icon"><i className="fas fa-globe"></i></span> Guerres d'Arran</strong></>
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SharedComicList;
